export const ANALYTICS_EVENTS = {
  BULK_OPERATION_EXECUTED: 'bulk_operation_executed',
  ENTITY_CREATED: 'entity_created',
  ENTITY_UPDATED: 'entity_updated',
  ENTITY_DELETED: 'entity_deleted',
  PAGE_VIEWED: 'page_viewed',
  ERROR_OCCURRED: 'error_occurred',
  FEEDBACK_SUBMITTED: 'feedback_submitted',
} as const;

export type AnalyticsEventName = (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];

export interface BulkOperationEvent {
  entity_type: string;
  action: string;
  count: number;
  duration_ms: number;
}

export interface EntityEvent {
  entity_type: string;
}

export interface PageViewEvent {
  page_name: string;
  load_time_ms?: number;
}

export interface ErrorEvent {
  error_type: string;
  page: string;
  severity: 'low' | 'medium' | 'high' | 'critical';
}

export interface FeedbackEvent {
  page: string;
  feedback_text: string;
}

export type AnalyticsEventProperties =
  | BulkOperationEvent
  | EntityEvent
  | PageViewEvent
  | ErrorEvent
  | FeedbackEvent
  | Record<string, unknown>;
